
import { CalendarEvent } from "@/types/calendar";

export const mockCalendarEvents: CalendarEvent[] = [
  {
    id: "1",
    title: "Technical Interview - Sarah Chen",
    description: "Senior Frontend Developer position discussion",
    start_time: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString(),
    end_time: new Date(Date.now() + 25 * 60 * 60 * 1000).toISOString(),
    location: "Conference Room A",
    attendees: ["sarah.chen@email.com", "hiring.manager@company.com"],
    type: "technical",
    status: "confirmed",
    source: "ai",
    ai_agent: "Scheduling Agent"
  },
  {
    id: "2", 
    title: "Client Meeting - Acme Corp",
    description: "Quarterly business review",
    start_time: new Date(Date.now() + 48 * 60 * 60 * 1000).toISOString(),
    end_time: new Date(Date.now() + 50 * 60 * 60 * 1000).toISOString(),
    location: "Virtual - Zoom",
    attendees: ["john.doe@acme.com"],
    type: "client",
    status: "confirmed",
    source: "manual"
  },
  {
    id: "3",
    title: "Phone Screening - Alex Rodriguez", 
    description: "Initial screening for Backend Developer role",
    start_time: new Date(Date.now() + 72 * 60 * 60 * 1000).toISOString(),
    end_time: new Date(Date.now() + 72.5 * 60 * 60 * 1000).toISOString(),
    type: "screening",
    status: "confirmed",
    source: "ai",
    ai_agent: "BrigAI Screening Bot"
  },
  {
    id: "4",
    title: "Team Standup",
    description: "Daily sync meeting",
    start_time: new Date(Date.now() + 96 * 60 * 60 * 1000).toISOString(), 
    end_time: new Date(Date.now() + 96.5 * 60 * 60 * 1000).toISOString(),
    type: "meeting",
    status: "confirmed",
    source: "manual"
  },
  {
    id: "5",
    title: "On-site Interview - Jessica Park",
    description: "Final round interview for Product Manager position",
    start_time: new Date(Date.now() + 120 * 60 * 60 * 1000).toISOString(),
    end_time: new Date(Date.now() + 122 * 60 * 60 * 1000).toISOString(),
    location: "Main Office - Floor 3",
    attendees: ["jessica.park@email.com", "team@company.com"],
    type: "onsite",
    status: "confirmed", 
    source: "ai",
    ai_agent: "Interview Coordinator"
  }
];
